// extracted by mini-css-extract-plugin
export var border = "_1o-8";
export var brand = "_1o-t";
export var button = "_1o-l";
export var center = "_1o-a";
export var centered = "_1o-6";
export var closeButton = "_1o-c";
export var disabledWrapper = "_1o-m";
export var error = "_1o-p";
export var extraLarge = "_1o-4";
export var extraSmall = "_1o-1";
export var fill = "_1o-i";
export var footer = "_1o-h";
export var footerAction = "_1o-j";
export var footerButtons = "_1o-k";
export var header = "_1o-7";
export var headerWithClose = "_1o-d";
export var icon = "_1o-o";
export var info = "_1o-s";
export var inline = "_1o-9";
export var large = "_1o-3";
export var main = "_1o-e";
export var modal = "_1o-0";
export var nearFull = "_1o-5";
export var neutral = "_1o-u";
export var noPadding = "_1o-g";
export var none = "_1o-v";
export var scrollable = "_1o-f";
export var small = "_1o-2";
export var success = "_1o-r";
export var tight = "_1o-n";
export var titleIcon = "_1o-b";
export var warn = "_1o-q";